import { LinkType } from '../../../components'
import { useLocalizedNews } from '../../../hooks'
import { ROUTE_MESSAGES_NEWS } from '../../../routes'
import { NewsContentType, UINewsTranslation } from '../../../utils'
import { MainContentSection } from './main-content-section'

export const MainContentNews = () => {
  const news = useLocalizedNews()
  let tabIndexCounter = 0

  return (
    <MainContentSection
      id="news"
      headerPrimaryId="pages.frontPage.sections.news.label"
      noSectionItemsMessageId="pages.frontPage.sections.news.emptyNews"
      sectionLinkGroups={news.map(
        (newsItem: UINewsTranslation, index: number) => {
          const isUrl = newsItem.type === NewsContentType.URL

          const lineUrl = isUrl
            ? newsItem.content
            : `${ROUTE_MESSAGES_NEWS}/${tabIndexCounter}`

          const linkType = isUrl ? LinkType.BASIC : LinkType.ROUTED

          if (!isUrl) {
            tabIndexCounter++
          }

          return {
            lineHeader: newsItem.formattedStartDate,
            linkItems: [
              {
                id: `news-item-${index}`,
                lineText: newsItem.header,
                lineUrl,
                type: linkType
              }
            ]
          }
        }
      )}
    />
  )
}
